import createClient, {type Middleware} from "openapi-fetch";
import Session from "supertokens-auth-react/recipe/session";
import type {paths} from "./api-types";
import {VITE_API_DOMAIN} from "@/config";

const authMiddleware: Middleware = {
  async onRequest({request}) {
    try {
      const accessToken = await Session.getAccessToken();
      if (accessToken) {
        request.headers.set("Authorization", `Bearer ${accessToken}`);
      }
    } catch {
      // Session not available, continue without auth header
    }
    return request;
  },
};

export const apiClient = createClient<paths>({
  baseUrl: VITE_API_DOMAIN,
});

apiClient.use(authMiddleware);
